import { createFileRoute, useParams } from '@tanstack/react-router';

import { UserDetailScreen } from '@/features/users/components/shared/UserDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/users/$userId')({
  beforeLoad: () => {
    requirePermission('user:read');
  },
  component: PlatformUserDetailRoute,
  staticData: { crumb: 'User' },
});

function PlatformUserDetailRoute() {
  const { userId } = useParams({
    from: '/_staff/admin/platform/users/$userId',
  });
  return <UserDetailScreen userId={userId} listPath="/admin/platform/users" surface="platform" />;
}
